export const ERROR_OLAS_LIST = 'movilidad/tracking/error-olas-list';
export const RECEIVE_OLAS_LIST = 'movilidad/tracking/receive-tracking-list';
export const REQUEST_OLAS_LIST = 'movilidad/tracking/request-tracking-list';
export const RESTART_STATE = 'movilidad/tracking/restart_state';
export const SET_MASK = 'movilidad/tracking/set-mask';
export const SET_ORDER = 'movilidad/tracking/set-order';
export const SET_SELECTED_ROW = 'movilidad/tracking/set-selected-row';
export const UPDATE_FIELD_FILTER = 'movilidad/tracking/update-field-filter';
export const UPDATE_TABLE_COLUMN = 'movilidad/tracking/set-selected-row';